import React from "react";
import { EstoquesMedicamentoProvider } from "./context/estoques-medicamento-context";
import { EstoquesMedicamento } from "./estoques-medicamento";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";

const EstoquesMedicamentoFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Estoque de Medicamentos"}>
            <EstoquesMedicamentoProvider>
                <EstoquesMedicamento />
            </EstoquesMedicamentoProvider>
        </BaseInternalFormFactory>
    );
};

export default EstoquesMedicamentoFactory;
